import React, { useCallback } from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { hideMapEntityView } from "@app/scene/map/store/mapMode/actions";

import styles from "./BackButton.module.scss";

const messages = defineMessages({
  backToList: {
    id: "map.entityRecord.backToList",
    defaultMessage: "Back to List",
    description: "Entity Record View - Back to List button",
  },
});

interface Props {
  className?: string;
  hideMapEntityView: typeof hideMapEntityView;
  label?: React.ReactNode;
  onClick?: () => void;
}

const BackButton: React.FC<Props> = ({ className, hideMapEntityView, label, onClick }) => {
  const intl = useIntl();

  const handleBackToList = useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      hideMapEntityView();
    }
  }, [hideMapEntityView, onClick]);

  return (
    <div className={cn(styles.container, className)}>
      <Button className={styles.btn} onClick={handleBackToList}>
        &larr;
        <span className={styles.btnLabel}>{label ?? intl.formatMessage(messages.backToList)}</span>
      </Button>
    </div>
  );
};

const mapDispatchToProps = {
  hideMapEntityView,
};

export default connect(null, mapDispatchToProps)(BackButton);
